import { useParams, Link, useNavigate } from "react-router-dom";
import PublicShell from "@/components/PublicShell";
import { fileUrl } from "@/lib/api";
import { ShareArtwork } from "@/components/ShareArtwork";
import { ProductGallery, PurchaseActions } from "@/components/art/ProductGallery";
import { MaterialPicker, SizePicker, FramePicker, MaterialFrameColorPicker } from "@/components/art/OptionPickers";
import { useArtworkOptions } from "@/hooks/useArtworkOptions";

export default function ArtDetailPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const o = useArtworkOptions(id);
  const { art } = o;

  if (!art) return <PublicShell><div className="max-w-[1400px] mx-auto px-6 py-24 text-mute">Loading…</div></PublicShell>;

  const handleBuyNow = () => { if (o.handleAdd()) nav("/cart"); };

  return (
    <PublicShell>
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-8 md:py-12">
        <Link to="/gallery" className="text-[11px] uppercase tracking-[0.22em] text-mute hover:text-ink" data-testid="back-to-gallery">← Back to Collection</Link>
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 mt-8">
          <ProductGallery art={art} activeSize={o.activeSize} material={o.material} soldOut={o.soldOut}
            frame={o.material === "poster" ? o.frame : (o.frameColorOptions.length ? { frame_color: o.materialFrameColor } : null)} />

          <div>
            <div className="overline text-mute mb-4">{art.category}</div>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight mb-4 text-ink">{art.title}</h1>
            {(art.medium || art.year) && (
              <div className="text-[11px] uppercase tracking-[0.22em] text-mute mb-6">
                {art.medium}{art.medium && art.year ? " · " : ""}{art.year}
              </div>
            )}
            {art.description && <p className="text-ink-soft leading-relaxed mt-6 mb-6">{art.description}</p>}
            <div className="mb-10"><ShareArtwork art={art} imageUrl={fileUrl(art.image_urls?.[0])} /></div>

            {art.prints_only && <MaterialPicker materials={o.materials} material={o.material} onChange={o.setMaterial} meta={o.currentMaterialMeta} />}
            <SizePicker art={art} material={o.material} size={o.size} onSize={o.setSize}
              materialSizes={o.materialSizes} materialSizeSel={o.materialSizeSel} onMaterialSize={o.setMaterialSizeSel} />
            {art.prints_only && o.material === "poster" && <FramePicker frames={o.frames} frame={o.frame} onChange={o.setFrame} />}
            {art.prints_only && o.material !== "poster" && <MaterialFrameColorPicker options={o.frameColorOptions} value={o.materialFrameColor} onChange={o.setMaterialFrameColor} />}
            <PurchaseActions soldOut={o.soldOut} totalPrice={o.totalPrice} onAdd={o.handleAdd} onBuyNow={handleBuyNow} />
          </div>
        </div>
      </section>
    </PublicShell>
  );
}
